import { Dialog, DialogProps, Grow } from "@mui/material";
import React from "react";

export const PiperDialog = ({ children, ...props }: DialogProps) => {
  return (
    <Dialog {...props} TransitionComponent={Grow}>
      {children}
    </Dialog>
  );
};
